// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__15Y61","icon":"SortAdornment_icon__3AjDb","up":"SortAdornment_up__3LDQa","down":"SortAdornment_down__2b-ED","active":"SortAdornment_active__tJnH3"};